import {SignalData} from '@domain/kiln-monitoring'
import {ApiClient} from '@hconnect/apiclient'
import type {HttpError} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import type {AxiosError} from 'axios'

const QueryKeyPrefix = 'kms-signals'
const REFETCH_INTERVAL_IN_MS = 1000 * 30

type SignalsParams = {
  plantId?: string
  kilnId: string
}

export const useGetSignals = <TData = SignalData[]>(
  {plantId, kilnId}: SignalsParams,
  options?: Omit<
    UseQueryOptions<SignalData[], AxiosError<HttpError>, TData>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<SignalData[], AxiosError<HttpError>, TData>({
    queryKey: [QueryKeyPrefix, plantId, kilnId],
    queryFn: async ({signal}) => {
      const path = `/kms/${plantId}/signals`
      const response = await ApiClient.axiosInstance.get<SignalData[]>(path, {
        params: {
          departmentId: kilnId
        },
        signal
      })

      return response.data
    },
    refetchInterval: REFETCH_INTERVAL_IN_MS,
    ...options
  })
}
